import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 9/14;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 9 14" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M4.56029 0.132617L0.893587 3.79934C0.716745 3.97618 0.716745 4.26289 0.893587 4.43971L1.32125 4.86737C1.49779 5.04391 1.78391 5.04425 1.96087 4.86813L4.88049 1.96219L7.80009 4.86813C7.97704 5.04425 8.26316 5.04391 8.4397 4.86737L8.86737 4.43971C9.04421 4.26287 9.04421 3.97616 8.86737 3.79934L5.20068 0.132617C5.02384 -0.0442061 4.73713 -0.0442061 4.56029 0.132617Z" fill={color}/>
        <path fillRule="evenodd" clipRule="evenodd" d="M4.56029 13.8674L0.893587 10.2007C0.716745 10.0238 0.716745 9.73711 0.893587 9.56029L1.32125 9.13263C1.49779 8.95609 1.78391 8.95575 1.96087 9.13187L4.88049 12.0378L7.80009 9.13187C7.97704 8.95575 8.26316 8.95609 8.4397 9.13263L8.86737 9.56029C9.04421 9.73713 9.04421 10.0238 8.86737 10.2007L5.20068 13.8674C5.02384 14.0442 4.73713 14.0442 4.56029 13.8674Z" fill={color}/>
    </svg>
)

export default class IconUpDown extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
